import { compose, withHandlers, withProps } from "recompose";
import ProposalForm from "./ProposalForm";
import { SubmissionError } from "redux-form";
import { next, ids } from "app/utils";
import { connectProposalActions } from "./hocs";
import { ADD } from "./constants";

const onSubmit = ({ createDraft }) => values => {
  const proposal = { ...values };
  delete proposal._id;
  delete proposal.ui;
  return createDraft({ proposal }).catch(error => {
    if (error && error.type === ADD.ERROR) {
      throw new SubmissionError({ _error: error });
    }
    throw error;
  });
};

const onSubmitSuccess = ({ topicId, history }) => props => {
  const { data: proposal } = props;
  const urlSearch = window.location.search;
  history.replace(`/topics/${topicId}/p/${proposal._id}${urlSearch}`);
};

const tmpProposal = topicId => ({
  _id: next(ids),
  content: { objects: [] },
  ui: {
    isTmp: true
  },
  topicId,
  description: ""
});

const configure = compose(
  withProps(props => {
    const { topicId } = props;
    return {
      initialValues: tmpProposal(topicId)
    };
  }),
  connectProposalActions,
  withHandlers({
    onSubmit,
    onSubmitSuccess
  })
);

export default configure(ProposalForm);



// WEBPACK FOOTER //
// ./src/app/proposals/ProposalAddForm.js